// Extrai uma mensagem legível de um erro axios: detail string, ou detail.message,
// ou err.message, ou o fallback. Usada pelos handlers de erro das páginas.
export function extractApiError(err, fallback = "Ocorreu um erro") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.message || err?.message || fallback;
}

export function NormalizeApiError(detail) {
  if (!detail) return "";
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const loc = Array.isArray(d.loc) ? d.loc.join(".") : d.loc;
        return `${d.msg}${loc ? ` (${loc})` : ""}`;
      })
      .join(" • ");
  }
  if (typeof detail === "object") {
    return detail.msg || JSON.stringify(detail);
  }
  return String(detail);
}
